import { render, staticRenderFns } from "./DevisVoyageView.vue?vue&type=template&id=68330e3b&scoped=true"
import script from "./DevisVoyageView.vue?vue&type=script&lang=js"
export * from "./DevisVoyageView.vue?vue&type=script&lang=js"
import style0 from "./DevisVoyageView.vue?vue&type=style&index=0&id=68330e3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68330e3b",
  null
  
)

export default component.exports